export const createContestsEditionStageTableEntriesRequests = (client) => ({
    listContestsEditionStageTableEntries: async (params) => {
        const { data, meta, links } = await client.api.get("contests_edition_stage_table_entries", {
            params: params,
        });
        return { data, meta, links };
    },
    getContestsEditionStageTableEntry: async (id, params) => {
        const { data } = await client.api.get(`contests_edition_stage_table_entries/${id}`, {
            params: params,
        });
        return { data };
    },
    createContestsEditionStageTableEntry: async (payload) => {
        const { data } = await client.api.create("contests_edition_stage_table_entries", payload);
        return { data };
    },
    updateContestsEditionStageTableEntry: async (payload) => {
        const { data } = await client.api.update("contests_edition_stage_table_entries", payload);
        return { data };
    },
    deleteContestsEditionStageTableEntry: async (id) => {
        return client.api.remove("contests_edition_stage_table_entries", id);
    },
});
//# sourceMappingURL=index.js.map